t = require('views/internal/teacup-with-helpers')('org_link_ga_helper')

module.exports = ->
  t.div '.ga-link-helper-section', ->

    t.p ->
      t.format '1-first-you-must-enable-administrative-api-access-for-your-google-apps-domain-you-can-find-instructions-for-doing-so-here'

    t.p ->
      t.format '2-next-you-ll-need-to-add-the-trello-business-class-app-from-the-google-apps-marketplace-to-your-domain-the-button-below-will-get-you-there'

    t.p ->
      t.format '3-when-there-be-sure-you-are-signed-in-to-the-google-account-with-the-correct-domain-you-want-to-use-click-the-integrate-with-google-button-then-follow-the-prompts'

    t.p ->
      t.format '4-you-ll-see-other-users-from-your-google-apps-domain-on-this-page-when-configured-correctly'

  t.a '.button.js-link', { style: 'width: 100%; padding: 7px 0;', target: '_blank', href: 'https://chrome.google.com/webstore/detail/trello-business-class/hmhbhkhihjbjgghmkhhniddhlojffhil' }, ->
    t.format 'go-to-google-apps-marketplace'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_link_ga_helper.coffee